var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowDownIcon = function SvgArrowDownIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.585 7.15-3.826 4.464a1 1 0 0 1-1.518 0L4.415 7.151a1 1 0 0 1 .76-1.651h7.65a1 1 0 0 1 .76 1.65"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjU4NSA3LjE1MDc5TDkuNzU5MjYgMTEuNjE0MkM5LjM2MDE2IDEyLjA3OTggOC42Mzk4NCAxMi4wNzk4IDguMjQwNzQgMTEuNjE0Mkw0LjQxNDk3IDcuMTUwNzlDMy44NTg5NiA2LjUwMjEyIDQuMzE5ODcgNS41IDUuMTc0MjIgNS41TDEyLjgyNTggNS41QzEzLjY4MDEgNS41IDE0LjE0MSA2LjUwMjEyIDEzLjU4NSA3LjE1MDc5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";